import dayjs from 'dayjs';

/**
 * Formats dates for `DateInput` and `DateRangeInput`
 *
 * @param {Date} date
 * @returns {string} Time zone formatted date string
 */
export const formatDatePickerInput = (date: Date): string =>
  dayjs(date).format('MMM DD, YYYY');
